import React, { useState, useEffect, useRef } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createBrowserHistory } from 'history';
//import { useNavigate } from 'react-router-dom';
import { eventAdded } from './eventsSlice'
import "bootstrap/dist/css/bootstrap.min.css";

import { Stack, TextField, Paper, Grid, Checkbox, FormGroup, InputAdornment, OutlinedInput, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Card, CardContent, CardActions, Button, ButtonGroup, Box, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import axios from 'axios'
import TimezoneSelect from 'react-timezone-select'
import ReactDOM from 'react-dom'
import { addNewEvent } from './eventsSlice'


export default function AddEvent(props) {
    const history = useHistory();
    //const history = createBrowserHistory();
    //const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isOrganizer, setIsOrganizer] = useState(false);
    const [isPlayer, setIsPlayer] = useState(false);
    const [userName, setUserName] = useState();
    const [idType, setIdType] = useState();
    const [playerId, setPlayerId] = useState();
    const [userRole, setUserRole] = useState("");


    const [eventName, setEventName] = useState('')
    const [eventType, setEventType] = useState('TNM')
    const [eventFormat, setEventFormat] = useState('INP')
    const [eventPlatform, setEventPlatform] = useState('OTB')
    const [eventEntry, setEventEntry] = useState('OPN')
    const [eventUscfRated, setEventUscfRated] = useState(true)
    const [eventUscfOnlineRated, setEventUscfOnlineRated] = useState(false)
    const [eventFideRated, setEventFideRated] = useState(false)
    const [eventNormPossible, setEventNormPossible] = useState(false)
    const [eventPlatformRated, setEventPlatformRated] = useState(false)
    const [eventPairingSystem, seteventPairingSystem] = useState('SWS')
    const [eventTimeControl, setEventTimeControl] = useState('CLA')

    const [eventRounds, setEventRounds] = useState(1)
    const [eventSeats, setEventSeats] = useState(1)
    const [eventPrizeFund, setEventPrizeFund] = useState(0)
    const [eventServiceLevel, setEventServiceLevel] = useState(1)
    const [eventDescription, setEventDescription] = useState('')
    const [eventAddress, setEventAddress] = useState('14820 NE 36th St')
    const [eventCity, setEventCity] = useState('Redmond')
    const [eventState, setEventState] = useState('WA')
    const [eventZipCode, setEventZipCode] = useState('98052')
    const [eventTimeZone, setEventTimeZone] = useState(
        "Pacific Standard Time"
    )
    var tempTime = new Date();
    tempTime.setDate(tempTime.getDate() + 1)
    tempTime.setHours(10);
    tempTime.setMinutes(0);
    tempTime.setMilliseconds(0);

    //default start time tomorrow 10am
    var tempTimeSting = tempTime.getFullYear() + "-" + ("0" + (tempTime.getMonth()+1)).slice(-2) + "-" + ("0" + (tempTime.getDate())).slice(-2) + "T" + ("0" + tempTime.getHours()).slice(-2) + ":" + ("0" + tempTime.getMinutes()).slice(-2);
    //var tempTimeSting = tempTime.getFullYear() + "-" + ("0" + tempTime.getMonth() + 1).slice(-2) + "-" + ("0" + (tempTime.getDate())).slice(-2) + "T" + ("0" + tempTime.getHours()).slice(-2) + ":" + ("0" + tempTime.getMinutes()).slice(-2);
    const [eventStartDateTime, setEventStartDateTime] = useState(tempTimeSting);

    //default registration deadline tomorrow 9:00AM
    tempTime.setHours(9);
    tempTime.setMinutes(0);
    tempTimeSting = tempTime.getFullYear() + "-" + ("0" + (tempTime.getMonth() + 1)).slice(-2) + "-" + ("0" + (tempTime.getDate())).slice(-2) + "T" + ("0" + tempTime.getHours()).slice(-2) + ":" + ("0" + tempTime.getMinutes()).slice(-2);
    const [eventRegistrationDeadline, setEventRegistrationDeadline] = useState(tempTimeSting);

    //default bye request deadline tomorrow9:30AM
    tempTime.setHours(9);
    tempTime.setMinutes(30);
    tempTimeSting = tempTime.getFullYear() + "-" + ("0" + (tempTime.getMonth() + 1)).slice(-2) + "-" + ("0" + (tempTime.getDate())).slice(-2) + "T" + ("0" + tempTime.getHours()).slice(-2) + ":" + ("0" + tempTime.getMinutes()).slice(-2);
    const [eventByeRequestDeadline, setEventByeRequestDeadline] = useState(tempTimeSting);

    //default endtime tomorrow 11pm
    tempTime.setHours(23);
    tempTime.setMinutes(0);
    tempTimeSting = tempTime.getFullYear() + "-" + ("0" + (tempTime.getMonth() + 1)).slice(-2) + "-" + ("0" + (tempTime.getDate())).slice(-2) + "T" + ("0" + tempTime.getHours()).slice(-2) + ":" + ("0" + tempTime.getMinutes()).slice(-2);
    const [eventEndDateTime, setEventEndDateTime] = useState(tempTimeSting);
    
    const [eventFlyerUrl, setEventFlyerUrl] = useState('https://www.nachesshub.com');
    const [eventRegistrationUrl, setEventRegistrationUrl] = useState('');
    const [eventPairingUrl, setEventPairingUrl] = useState('');
    const [eventLiveGameUrl, setEventLiveGameUrl] = useState('');
    const [eventHotelReservationLink, setEventHotelReservationLink] = useState('');
    const [eventFideRegistrationLink, setEventFideRegistrationLink] = useState('');

    const types = {
        TNM: 'Tournament',
        LEC: 'Lecture',
        CMP: 'Camp',
        GPL: 'Group Lesson',
        SIM: 'Simul Exhibition',
        OTH: 'Other'
    };
    const formats = {
        INP: 'In Person',
        HYB: 'Hybrid',
        OLN: 'Online',
        OTH: 'Other',
    };
    const platforms = {
        OTB: 'Over The Board',
        CHE: 'Chess.com',
        LIC: 'Lichess.org',
        C24: 'Chess24.com',
        TON: 'Tornelo',
        ZOM: 'Zoom',
        OTH: 'Other'
    };
    const entries = {
        OPN: 'Open',
        CLO: 'Closed',
        INV: 'Invitational',
        OTH: 'Other',
    };
    const pairings = {
        SWS: 'Swiss',
        RRB: 'Round Robin',
        DRR: 'Double RR',
        SCL: 'Schiller',
        SVN: 'Scheveningen (Team)',
        KNO: 'Knock Out',
        OTH: 'Other'
    };
    const timeControls = {
        CLA: 'Classical',
        DUL: 'Dual',
        RPD: 'Rapid/Quick',
        BLT: 'Blitz',
        BUL: 'Bullet',
        ODD: 'Time Odds',
        OTH: 'Other',
    };

    const [addRequestStatus, setAddRequestStatus] = useState('idle')

    const dispatch = useDispatch()

    const [openEventFideRatedAlert, setOpenEventFideRatedAlert] = React.useState(false);

    //const canSave =
    //    [eventName, eventDescription, eventStartDateTime, eventEndDateTime, eventFlyerUrl  ].every(Boolean) && addRequestStatus === 'idle'

    const canSave =
        [eventName].every(Boolean) && addRequestStatus === 'idle'


    const handleCloseFideEventAlert = () => {
        setOpenEventFideRatedAlert(false);
    };


    useEffect(async () => {
        async function fetchData() {
            setAuthenticated(await authService.isAuthenticated());
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                setUserName(user.sub);
                if (user.sub.includes("FIDE")) {
                    setIsPlayer(true);
                    setIdType("FIDE");
                    setPlayerId(user.sub.replace("FIDE", ""));
                } else if (user.sub.includes("Affiliate")) {
                    setIsPlayer(false);
                    setIsOrganizer(true);
                }
                else if (user.sub.includes("USCF")) {
                    setIsPlayer(true);
                    setIdType("USCF");
                    setPlayerId(user.sub.replace("USCF", ""));
                }

                setUserRole(role);
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }
        }
        fetchData();
    }, [])


    const handleEventFormatChange = (event: SelectChangeEvent) => {
        setEventFormat(event.target.value);
    };

    const handleEventPlatformChange = (event: SelectChangeEvent) => {
        setEventPlatform(event.target.value);
        if (event.target.value === 'OTB' || event.target.value === 'ZOM' && event.target.value === 'OTH') {
            setEventPlatformRated(false);
        }
        if (event.target.value === 'OTB') {
            setEventUscfOnlineRated(false);
        }
    };

    const handleEventTypeChange = (event: SelectChangeEvent) => {
        setEventType(event.target.value);
    };

    const handleEventEntryChange = (event: SelectChangeEvent) => {
        setEventEntry(event.target.value);
    };

    const handleEventeventPairingSystemChange = (event: SelectChangeEvent) => {
        seteventPairingSystem(event.target.value);
    };

    const handleEventTimeControlChange = (event: SelectChangeEvent) => {
        setEventTimeControl(event.target.value);
    };
    
    //const handleServiceLevelChange = (event: SelectChangeEvent) => {
    //    setServiceLevel(event.target.value);
    //};

    const handleEventStateChange = (event: SelectChangeEvent) => {
        setEventState(event.target.value);
    };




    const handleEventTimeZoneChange = (event: SelectChangeEvent) => {
        setEventTimeZone(event.target.value);
    };

    //const onAddEventClicked = () => {
    //    if (eventName && eventDescription) {
    //        dispatch(eventAdded(
    //            eventName,
    //            eventType,
    //            eventFormat,
    //            eventPlatform,
    //            eventEntry,
    //            eventUscfRated,
    //            eventFideRated,
    //            eventPlatformRated,
    //            eventPairingSystem,
    //            eventTimeControl,
    //            eventRounds,
    //            eventPrizeFund,
    //            eventServiceLevel,
    //            eventDescription,
    //            eventAddress,
    //            eventCity,
    //            eventState,
    //            eventZipCode,
    //            eventTimeZone,
    //            eventStartDateTime,
    //            eventEndDateTime,
    //            eventRegistrationDeadline,
    //            eventByeRequestDeadline,
    //            eventFlyerUrl,
    //            eventRegistrationUrl,
    //            eventPairingUrl,
    //            eventLiveGameUrl,
    //            eventHotelReservationLink,
    //            eventFideRegistrationLink,
    //        ))

    //        setName('')
    //        seteventDescription('')
    //    }
    //}

    const onAddEventClicked = async () => {
        var eventId = '';
        if (canSave) {
            try {
                setAddRequestStatus('pending')
                var createdEvent = await dispatch(addNewEvent({
                    eventName,
                    eventType,
                    eventFormat,
                    eventPlatform,
                    eventEntry,
                    eventUscfRated,
                    eventUscfOnlineRated,
                    eventFideRated,
                    eventNormPossible,
                    eventPlatformRated,
                    eventPairingSystem,
                    eventTimeControl,
                    eventRounds,
                    eventSeats,
                    eventPrizeFund,
                    eventServiceLevel,
                    eventDescription,
                    eventAddress,
                    eventCity,
                    eventState,
                    eventZipCode,
                    eventTimeZone,
                    eventStartDateTime,
                    eventEndDateTime,
                    eventRegistrationDeadline,
                    eventByeRequestDeadline,
                    eventFlyerUrl,
                    eventRegistrationUrl,
                    eventPairingUrl,
                    eventLiveGameUrl,
                    eventHotelReservationLink,
                    eventFideRegistrationLink
                })).unwrap();
                console.log(createdEvent);
                eventId = createdEvent.eventID;
            } catch (err) {
                console.error('Failed to save the event: ', err)
            } finally {
                setAddRequestStatus('idle')
            }
        }
        if (eventId !== '') {
            history.push(`/editEvent/${eventId}`); //https://stackoverflow.com/questions/50925939/react-history-push-not-rendering-new-component
            //history.push(`/events`);
        }
    }

    const onCancelClicked = () => {
        history.push(`/Events/`);
    }

    const onClearFormClicked = () => {
        setEventName('');
        setEventType('TNM');
        setEventFormat('INP');
        setEventPlatform('OTB');
        setEventEntry('OPN');
        setEventUscfRated(true);
        setEventUscfOnlineRated(false);
        setEventFideRated(false);
        setEventPlatformRated(false);
        seteventPairingSystem('SWS');
        setEventTimeControl('CLA');
        setEventRounds(1);
        setEventSeats(1);
        setEventPrizeFund(0);
        setEventServiceLevel(1);
        setEventDescription('');
        setEventAddress('');
        setEventCity('');
        setEventState('WA');
        setEventZipCode('');
        setEventTimeZone("Pacific Standard Time");
        setEventStartDateTime(((new Date())));
        setEventEndDateTime(((new Date())));
        setEventRegistrationDeadline(((new Date())));
        setEventByeRequestDeadline(((new Date())));
        setEventFlyerUrl('');
        setEventRegistrationUrl('');
        setEventPairingUrl('');
        setEventLiveGameUrl('');
        setEventHotelReservationLink('');
        setEventFideRegistrationLink('');
    }
   

    return (
        <div>
        
        {(isOrganizer || isAdmin) && 
            <div>
            <Typography variant="h5" gutterBottom>
                {'Add New Event '+ (eventName ? ': '+eventName: '')}
            </Typography>
            <Box my={2}>
                <Paper my={2} elevation={3} >
                    <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                        <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />}>
                            <Typography color='primary'>Basic Info</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                                <Grid item xs={12} lg={6}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                        <InputLabel fullWidth id="event-name-helper-label"></InputLabel>
                                        <TextField
                                            autoFocus={ true}
                                            labelId="event-name-helper-label"



                                            size="small"
                                            fullWidth
                                            id="event-name"
                                            label='Event Name'
                                            InputLabelProps={{ shrink: true, }}
                                            value={eventName}
                                            onChange={async (e) => { await setEventName(e.target.value) }}
                                            />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="event-type-select-helper-label">Type</InputLabel>
                                        <Select
                                            labelId="event-type-select-helper-label"
                                            id="type-select"
                                            value={eventType}
                                            label="Type"
                                            size="small"
                                            fullWidth
                                            required
                                            onChange={handleEventTypeChange}
                                        >
                                            <MenuItem value={'TNM'}>Tournament</MenuItem>
                                            <MenuItem value={'LEC'}>Lecture</MenuItem>
                                            <MenuItem value={'CMP'}>Camp</MenuItem>
                                            <MenuItem value={'GPL'}>Group Lesson</MenuItem>
                                            <MenuItem value={'SIM'}>Simul Exhibition</MenuItem>
                                            <MenuItem value={'OTH'}>Other</MenuItem>
                                        </Select>
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="event-format-select-helper-label">Format</InputLabel>
                                        <Select
                                            labelId="event-format-select-helper-label"
                                            id="event-format-select"
                                            value={eventFormat}
                                            label="Format"
                                            size="small"
                                            fullWidth
                                            required
                                            onChange={handleEventFormatChange}
                                        >
                                            <MenuItem value={'INP'}>In Person</MenuItem>
                                            <MenuItem value={'OLN'}>Online</MenuItem>
                                            <MenuItem value={'HYB'}>Hybrid</MenuItem>
                                            <MenuItem value={'OTH'}>Other</MenuItem>
                                        </Select>
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                        <InputLabel fullWidth id="event-format-select-helper-label">Platform</InputLabel>
                                        <Select
                                            labelId="event-format-select-helper-label"
                                            id="event-format-select"
                                            value={eventPlatform}
                                            label="Platform"
                                            size="small"
                                            fullWidth
                                            required
                                            onChange={handleEventPlatformChange}
                                        >
                                            <MenuItem value={'OTB'}>Over the Board</MenuItem>
                                            <MenuItem value={'CHE'}>Chess.com</MenuItem>
                                            <MenuItem value={'LIC'}>Lichess.org</MenuItem>
                                            <MenuItem value={'C24'}>Chess24.com</MenuItem>
                                            <MenuItem value={'TON'}>Tornelo</MenuItem>
                                            <MenuItem value={'ZOM'}>Zoom</MenuItem>
                                            <MenuItem value={'OTH'}>Other</MenuItem>
                                        </Select>
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <FormGroup row={true} >
                                            {/*<FormControlLabel control={<Checkbox checked={eventUscfRated} size="small" onChange={async (e) => { await setEventUscfRated(e.target.checked); if (eventUscfOnlineRated && e.target.checked) { await setEventUscfOnlineRated(false) } }} />} label="USCF Rated" />*/}
                                            {/*<FormControlLabel control={<Checkbox checked={eventUscfOnlineRated} size="small" onChange={async (e) => { await setEventUscfOnlineRated(e.target.checked); if (eventUscfRated && e.target.checked) { await setEventUscf(false) } }} />} label="USCF Online Rated" />*/}
                                            {/*<FormControlLabel control={<Checkbox checked={eventFideRated} size="small" onChange={async (e) => { await setEventFideRated(e.target.checked); await setOpenEventFideRatedAlert(e.target.checked); }} />} label="FIDE Rated" />*/}
                                            <FormControlLabel control={<Checkbox checked={eventUscfRated} size="small" onChange={async (e) => { await setEventUscfRated(e.target.checked); if (eventUscfOnlineRated && e.target.checked) { await setEventUscfOnlineRated(false) } }} />} label="USCF Rated" />
                                            {(eventPlatform === "CHE" || eventPlatform === "LIC" || eventPlatform === "C24" || eventPlatform === "TON") &&
                                                <FormControlLabel control={<Checkbox checked={eventUscfOnlineRated} size="small" onChange={async (e) => { await setEventUscfOnlineRated(e.target.checked); if (eventUscfRated && e.target.checked) { await setEventUscfRated(false) } }} />} label="USCF Online Rated" />
                                            }
                                            
                                            {(eventPlatform === "CHE" || eventPlatform === "LIC" || eventPlatform === "C24" || eventPlatform ==="TON" ) &&
                                                <FormControlLabel control={<Checkbox checked={eventPlatformRated} size="small" onChange={async (e) => { await setEventPlatformRated(e.target.checked) }} />} label={platforms[eventPlatform]+" rated"}/>
                                            }
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="event-eventPairingSystem-select-helper-label">Pairing System</InputLabel>
                                        <Select
                                            labelId="event-eventPairingSystem-select-helper-label"
                                            id="event-eventPairingSystem-select"
                                            value={eventPairingSystem}
                                            label="Pairing System"
                                            size="small"
                                            fullWidth
                                            required
                                            onChange={handleEventeventPairingSystemChange}
                                        >
                                            <MenuItem value={'SWS'}>Swiss</MenuItem>
                                            <MenuItem value={'RRB'}>Round Robin</MenuItem>
                                            <MenuItem value={'DRR'}>Double RR</MenuItem>
                                            <MenuItem value={'SCL'}>Schiller</MenuItem>
                                            <MenuItem value={'SVN'}>Scheveningen (Team)</MenuItem>
                                            <MenuItem value={'KNO'}>Knock Out</MenuItem>
                                            <MenuItem value={'OTH'}>Other</MenuItem>
                                        </Select>
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="evnet-timecontrol-select-helper-label">Time Control</InputLabel>
                                        <Select
                                            labelId="evnet-timecontrol-select-helper-label"
                                            id="evnet-timecontrol-select"
                                            value={eventTimeControl}
                                            label="Time Control"
                                            size="small"
                                            fullWidth
                                            required
                                            onChange={handleEventTimeControlChange}
                                        >
                                            <MenuItem value={'CLA'}>Classical</MenuItem>
                                            <MenuItem value={'DUL'}>Dual</MenuItem>
                                            <MenuItem value={'RPD'}>Rapid/Quick</MenuItem>
                                            <MenuItem value={'BLT'}>Blitz</MenuItem>
                                            <MenuItem value={'BUL'}>Bullet</MenuItem>
                                            <MenuItem value={'ODD'}>Time Odds</MenuItem>
                                            <MenuItem value={'OTH'}>Other</MenuItem>
                                        </Select>
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="event-entry-select-helper-label">Entry</InputLabel>
                                        <Select
                                            labelId="event-entry-select-helper-label"
                                            id="event-entry-select"
                                            value={eventEntry}
                                            label="Entry"
                                            size="small"
                                            fullWidth
                                            required
                                            onChange={handleEventEntryChange}
                                        >
                                            <MenuItem value={'OPN'}>Open</MenuItem>
                                            <MenuItem value={'CLO'}>Closed</MenuItem>
                                            <MenuItem value={'INV'}>Invitational</MenuItem>
                                            <MenuItem value={'OTH'}>Other</MenuItem>
                                        </Select>
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <FormGroup row={true} >
                                            <FormControlLabel control={<Checkbox checked={eventFideRated} size="small" onChange={async (e) => { await setEventFideRated(e.target.checked); await setOpenEventFideRatedAlert(e.target.checked); }} />} label="FIDE Rated" />
                                                <FormControlLabel control={<Checkbox checked={eventNormPossible} size="small" onChange={async (e) => { await setEventNormPossible(e.target.checked); {if (e.target.checked) { await setEventFideRated(true) } } }} />} label="Norm Possible" />
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="event-round-helper-label"></InputLabel>
                                        <TextField
                                            labelId="event-round-helper-label"
                                            required
                                            size="small"
                                            fullWidth
                                            id="event-round"
                                            label='Rounds'
                                            type='number'
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                            InputLabelProps={{ shrink: true, }}
                                            value={eventRounds}
                                            onChange={async (e) => { await setEventRounds(e.target.value) }}
                                        />
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="event-seats-helper-label"></InputLabel>
                                        <TextField
                                            labelId="event-seats-helper-label"
                                            required
                                            size="small"
                                            fullWidth
                                            id="event-round"
                                            label='Seats'
                                            type='number'
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                            InputLabelProps={{ shrink: true, }}
                                            value={eventSeats}
                                            onChange={async (e) => { await setEventSeats(e.target.value) }}
                                        />
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                        <InputLabel fullWidth id="eventPrizeFund-label">Prize Fund</InputLabel>
                                        {/*<TextField*/}
                                        {/*    labelId="event-name-helper-label"*/}
                                        {/*    required*/}
                                        {/*    size="small"*/}
                                        {/*    fullWidth*/}
                                        {/*    id="event-eventPrizeFund"*/}
                                        {/*    label='Prize Fund'*/}
                                        {/*    type='number'*/}
                                        {/*    InputProps={{*/}
                                        {/*        inputProps: {*/}
                                        {/*            min: 0*/}
                                        {/*        }*/}
                                        {/*    }}*/}
                                        {/*    startAdornment={<InputAdornment position="start">$</InputAdornment>}*/}
                                        {/*    InputLabelProps={{ shrink: true, }}*/}
                                        {/*    value={eventPrizeFund}*/}
                                        {/*    onChange={async (e) => { await seteventPrizeFund(e.target.value) }}*/}
                                        {/*/>*/}
                                        <OutlinedInput
                                            size="small"
                                            labelId="eventPrizeFund-label"
                                            id="eventPrizeFund"
                                            type='number'
                                            value={eventPrizeFund}
                                            onChange={async (e) => { await setEventPrizeFund(e.target.value) }}
                                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                            label="Prize Fund"
                                        />
                                        {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                    </FormControl>
                                </Grid>
                                
                                {/*<Grid item xs={12} lg={3}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="servicelevel-select-helper-label">Service Level</InputLabel>*/}
                                {/*        <Select*/}
                                {/*            labelId="servicelevel-select-helper-label"*/}
                                {/*            id="servicelevel-select"*/}
                                {/*            value={serviceLevel}*/}
                                {/*            label="Service Level"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            required*/}
                                {/*            onChange={handleServiceLevelChange}*/}
                                {/*        >*/}
                                {/*            <MenuItem value={1}>L1 - Publish Only</MenuItem>*/}
                                {/*            <MenuItem value={2}>L2 - Publish & Register</MenuItem>*/}
                                {/*            <MenuItem value={3}>L3 - Publish & Register & Pay</MenuItem>*/}
                                {/*            <MenuItem value={3}>L4 - Publish & Register & Pay & Results</MenuItem>*/}
                                {/*        </Select>*/}
                                {/*        */}{/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                            </Grid>
                            <Grid container direction="row" rowSpacing={1} columnSpacing={1} justify-content="space-between" align-items="stretch">
                                {/*<Grid item xs={12} lg={3}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="address-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="address-helper-label"*/}
                                {/*            required*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="address"*/}
                                {/*            label='Address'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventAddress}*/}
                                {/*            onChange={async (e) => { await setEventAddress(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={12} lg={2}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="city-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="city-helper-label"*/}
                                {/*            required*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            required*/}
                                {/*            id="city"*/}
                                {/*            label='City'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventCity}*/}
                                {/*            onChange={async (e) => { await setEventCity(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={6} lg={2}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="state-helper-label">State</InputLabel>*/}
                                {/*        <Select*/}
                                {/*            labelId="state-helper-label"*/}
                                {/*            id="state-select"*/}
                                {/*            value={eventState}*/}
                                {/*            label="State"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            onChange={handleEventStateChange}*/}
                                {/*        >*/}
                                {/*            <MenuItem value={"AL"}>Alabama</MenuItem>*/}
                                {/*            <MenuItem value={"AK"}>Alaska</MenuItem>*/}
                                {/*            <MenuItem value={"AZ"}>Arizona</MenuItem>*/}
                                {/*            <MenuItem value={"AR"}>Arkansas</MenuItem>*/}
                                {/*            <MenuItem value={"CA"}>California</MenuItem>*/}
                                {/*            <MenuItem value={"CO"}>Colorado</MenuItem>*/}
                                {/*            <MenuItem value={"CT"}>Connecticut</MenuItem>*/}
                                {/*            <MenuItem value={"DE"}>Delaware</MenuItem>*/}
                                {/*            <MenuItem value={"FL"}>Florida</MenuItem>*/}
                                {/*            <MenuItem value={"GA"}>Georgia</MenuItem>*/}
                                {/*            <MenuItem value={"HI"}>Hawaii</MenuItem>*/}
                                {/*            <MenuItem value={"ID"}>Idaho</MenuItem>*/}
                                {/*            <MenuItem value={"IL"}>Illinois</MenuItem>*/}
                                {/*            <MenuItem value={"IN"}>Indiana</MenuItem>*/}
                                {/*            <MenuItem value={"IA"}>Iowa</MenuItem>*/}
                                {/*            <MenuItem value={"KS"}>Kansas</MenuItem>*/}
                                {/*            <MenuItem value={"KY"}>Kentucky</MenuItem>*/}
                                {/*            <MenuItem value={"LA"}>Louisiana</MenuItem>*/}
                                {/*            <MenuItem value={"ME"}>Maine</MenuItem>*/}
                                {/*            <MenuItem value={"MD"}>Maryland</MenuItem>*/}
                                {/*            <MenuItem value={"MA"}>Massachusetts</MenuItem>*/}
                                {/*            <MenuItem value={"MI"}>Michigan</MenuItem>*/}
                                {/*            <MenuItem value={"MN"}>Minnesota</MenuItem>*/}
                                {/*            <MenuItem value={"MS"}>Mississippi</MenuItem>*/}
                                {/*            <MenuItem value={"MO"}>Missouri</MenuItem>*/}
                                {/*            <MenuItem value={"MT"}>Montana</MenuItem>*/}
                                {/*            <MenuItem value={"NE"}>Nebraska</MenuItem>*/}
                                {/*            <MenuItem value={"NV"}>Nevada</MenuItem>*/}
                                {/*            <MenuItem value={"NH"}>New Hampshire</MenuItem>*/}
                                {/*            <MenuItem value={"NJ"}>New Jersey</MenuItem>*/}
                                {/*            <MenuItem value={"NM"}>New Mexico</MenuItem>*/}
                                {/*            <MenuItem value={"NY"}>New York</MenuItem>*/}
                                {/*            <MenuItem value={"NC"}>North Carolina</MenuItem>*/}
                                {/*            <MenuItem value={"ND"}>North Dakota</MenuItem>*/}
                                {/*            <MenuItem value={"OH"}>Ohio</MenuItem>*/}
                                {/*            <MenuItem value={"OK"}>Oklahoma</MenuItem>*/}
                                {/*            <MenuItem value={"OR"}>Oregon</MenuItem>*/}
                                {/*            <MenuItem value={"PA"}>Pennsylvania</MenuItem>*/}
                                {/*            <MenuItem value={"RI"}>Rhode Island</MenuItem>*/}
                                {/*            <MenuItem value={"SC"}>South Carolina</MenuItem>*/}
                                {/*            <MenuItem value={"SD"}>South Dakota</MenuItem>*/}
                                {/*            <MenuItem value={"TN"}>Tennessee</MenuItem>*/}
                                {/*            <MenuItem value={"TX"}>Texas</MenuItem>*/}
                                {/*            <MenuItem value={"UT"}>Utah</MenuItem>*/}
                                {/*            <MenuItem value={"VT"}>Vermont</MenuItem>*/}
                                {/*            <MenuItem value={"VA"}>Virginia</MenuItem>*/}
                                {/*            <MenuItem value={"WA"}>Washington</MenuItem>*/}
                                {/*            <MenuItem value={"WV"}>West Virginia</MenuItem>*/}
                                {/*            <MenuItem value={"WI"}>Wisconsin</MenuItem>*/}
                                {/*            <MenuItem value={"WY"}>Wyoming</MenuItem>*/}

                                {/*        </Select>*/}
                                {/*        */}{/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={6} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <InputLabel fullWidth id="zipcode-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="zipcode-helper-label"*/}
                                {/*            required*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="zipcode"*/}
                                {/*            label='Zip Code'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventZipCode}*/}
                                {/*            onChange={async (e) => { await setEventZipCode(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                
                                <Grid item xs={12} lg={3}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                        <InputLabel fullWidth id="eventStartDateTime-helper-label"></InputLabel>
                                        <TextField
                                            labelId="eventStartDateTime-helper-label"
                                            required
                                            size="small"
                                            fullWidth
                                            id="eventStartDateTime"
                                            label='Start Date and Time'
                                            type='datetime-local'
                                            InputLabelProps={{ shrink: true, }}
                                            value={eventStartDateTime}
                                                    onChange={async (e) => { await setEventStartDateTime(e.target.value);  }}
                                        />
                                    </FormControl>
                                </Grid>

                                {/*<Grid item xs={12} lg={2}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <FormGroup>*/}
                                {/*            <FormControlLabel control={<Checkbox defaultChecked size="small" />} label="FIDE Rated" />*/}
                                {/*        </FormGroup>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={12} lg={2}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <FormGroup>*/}
                                {/*            <FormControlLabel control={<Checkbox defaultChecked size="small" />} label="Online Rated" />*/}
                                {/*        </FormGroup>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                <Grid item xs={12} lg={3}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                        <InputLabel fullWidth id="eventEndDateTime-helper-label"></InputLabel>
                                        <TextField
                                            labelId="eventEndDateTime-helper-label"
                                            required
                                            size="small"
                                            fullWidth
                                            id="eventEndDateTime"
                                            label='End Date and Time'
                                            type='datetime-local'
                                            InputLabelProps={{ shrink: true, }}
                                            value={eventEndDateTime}
                                            onChange={async (e) => { await setEventEndDateTime(e.target.value) }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                        <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>
                                            <InputLabel fullWidth id="timezone-helper-label">Time Zone</InputLabel>
                                            <Select
                                                labelId="timezone-helper-label"
                                                id="timezone-select"
                                                value={eventTimeZone}
                                                label="Time Zone"
                                                size="small"
                                                fullWidth
                                                required
                                                onChange={handleEventTimeZoneChange}
                                            >
                                                <MenuItem value={"Morocco Standard Time"}>(GMT) Casablanca</MenuItem>
                                                <MenuItem value={"GMT Standard Time"}>(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London</MenuItem>
                                                <MenuItem value={"Greenwich Standard Time"}>(GMT) Monrovia, Reykjavik</MenuItem>
                                                <MenuItem value={"W. Europe Standard Time"}>(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna</MenuItem>
                                                <MenuItem value={"Central Europe Standard Time"}>(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague</MenuItem>
                                                <MenuItem value={"Romance Standard Time"}>(GMT+01:00) Brussels, Copenhagen, Madrid, Paris</MenuItem>
                                                <MenuItem value={"Central European Standard Time"}>(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb</MenuItem>
                                                <MenuItem value={"W. Central Africa Standard Time"}>(GMT+01:00) West Central Africa</MenuItem>
                                                <MenuItem value={"Jordan Standard Time"}>(GMT+02:00) Amman</MenuItem>
                                                <MenuItem value={"GTB Standard Time"}>(GMT+02:00) Athens, Bucharest, Istanbul</MenuItem>
                                                <MenuItem value={"Middle East Standard Time"}>(GMT+02:00) Beirut</MenuItem>
                                                <MenuItem value={"Egypt Standard Time"}>(GMT+02:00) Cairo</MenuItem>
                                                <MenuItem value={"South Africa Standard Time"}>(GMT+02:00) Harare, Pretoria</MenuItem>
                                                <MenuItem value={"FLE Standard Time"}>(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius</MenuItem>
                                                <MenuItem value={"Israel Standard Time"}>(GMT+02:00) Jerusalem</MenuItem>
                                                <MenuItem value={"E. Europe Standard Time"}>(GMT+02:00) Minsk</MenuItem>
                                                <MenuItem value={"Namibia Standard Time"}>(GMT+02:00) Windhoek</MenuItem>
                                                <MenuItem value={"Arabic Standard Time"}>(GMT+03:00) Baghdad</MenuItem>
                                                <MenuItem value={"Arab Standard Time"}>(GMT+03:00) Kuwait, Riyadh</MenuItem>
                                                <MenuItem value={"Russian Standard Time"}>(GMT+03:00) Moscow, St. Petersburg, Volgograd</MenuItem>
                                                <MenuItem value={"E. Africa Standard Time"}>(GMT+03:00) Nairobi</MenuItem>
                                                <MenuItem value={"Georgian Standard Time"}>(GMT+03:00) Tbilisi</MenuItem>
                                                <MenuItem value={"Iran Standard Time"}>(GMT+03:30) Tehran</MenuItem>
                                                <MenuItem value={"Arabian Standard Time"}>(GMT+04:00) Abu Dhabi, Muscat</MenuItem>
                                                <MenuItem value={"Azerbaijan Standard Time"}>(GMT+04:00) Baku</MenuItem>
                                                <MenuItem value={"Mauritius Standard Time"}>(GMT+04:00) Port Louis</MenuItem>
                                                <MenuItem value={"Caucasus Standard Time"}>(GMT+04:00) Yerevan</MenuItem>
                                                <MenuItem value={"Afghanistan Standard Time"}>(GMT+04:30) Kabul</MenuItem>
                                                <MenuItem value={"Ekaterinburg Standard Time"}>(GMT+05:00) Ekaterinburg</MenuItem>
                                                <MenuItem value={"Pakistan Standard Time"}>(GMT+05:00) Islamabad, Karachi</MenuItem>
                                                <MenuItem value={"West Asia Standard Time"}>(GMT+05:00) Tashkent</MenuItem>
                                                <MenuItem value={"India Standard Time"}>(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi</MenuItem>
                                                <MenuItem value={"Sri Lanka Standard Time"}>(GMT+05:30) Sri Jayawardenepura</MenuItem>
                                                <MenuItem value={"Nepal Standard Time"}>(GMT+05:45) Kathmandu</MenuItem>
                                                <MenuItem value={"N. Central Asia Standard Time"}>(GMT+06:00) Almaty, Novosibirsk</MenuItem>
                                                <MenuItem value={"Central Asia Standard Time"}>(GMT+06:00) Astana, Dhaka</MenuItem>
                                                <MenuItem value={"Myanmar Standard Time"}>(GMT+06:30) Yangon (Rangoon)</MenuItem>
                                                <MenuItem value={"SE Asia Standard Time"}>(GMT+07:00) Bangkok, Hanoi, Jakarta</MenuItem>
                                                <MenuItem value={"North Asia Standard Time"}>(GMT+07:00) Krasnoyarsk</MenuItem>
                                                <MenuItem value={"China Standard Time"}>(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi</MenuItem>
                                                <MenuItem value={"North Asia East Standard Time"}>(GMT+08:00) Irkutsk, Ulaan Bataar</MenuItem>
                                                <MenuItem value={"Singapore Standard Time"}>(GMT+08:00) Kuala Lumpur, Singapore</MenuItem>
                                                <MenuItem value={"W. Australia Standard Time"}>(GMT+08:00) Perth</MenuItem>
                                                <MenuItem value={"Taipei Standard Time"}>(GMT+08:00) Taipei</MenuItem>
                                                <MenuItem value={"Tokyo Standard Time"}>(GMT+09:00) Osaka, Sapporo, Tokyo</MenuItem>
                                                <MenuItem value={"Korea Standard Time"}>(GMT+09:00) Seoul</MenuItem>
                                                <MenuItem value={"Yakutsk Standard Time"}>(GMT+09:00) Yakutsk</MenuItem>
                                                <MenuItem value={"Cen. Australia Standard Time"}>(GMT+09:30) Adelaide</MenuItem>
                                                <MenuItem value={"AUS Central Standard Time"}>(GMT+09:30) Darwin</MenuItem>
                                                <MenuItem value={"E. Australia Standard Time"}>(GMT+10:00) Brisbane</MenuItem>
                                                <MenuItem value={"AUS Eastern Standard Time"}>(GMT+10:00) Canberra, Melbourne, Sydney</MenuItem>
                                                <MenuItem value={"West Pacific Standard Time"}>(GMT+10:00) Guam, Port Moresby</MenuItem>
                                                <MenuItem value={"Tasmania Standard Time"}>(GMT+10:00) Hobart</MenuItem>
                                                <MenuItem value={"Vladivostok Standard Time"}>(GMT+10:00) Vladivostok</MenuItem>
                                                <MenuItem value={"Central Pacific Standard Time"}>(GMT+11:00) Magadan, Solomon Is., New Caledonia</MenuItem>
                                                <MenuItem value={"New Zealand Standard Time"}>(GMT+12:00) Auckland, Wellington</MenuItem>
                                                <MenuItem value={"Fiji Standard Time"}>(GMT+12:00) Fiji, Kamchatka, Marshall Is.</MenuItem>
                                                <MenuItem value={"Tonga Standard Time"}>(GMT+13:00) Nuku'alofa</MenuItem>
                                                <MenuItem value={"Azores Standard Time"}>(GMT-01:00) Azores</MenuItem>
                                                <MenuItem value={"Cape Verde Standard Time"}>(GMT-01:00) Cape Verde Is.</MenuItem>
                                                <MenuItem value={"Mid-Atlantic Standard Time"}>(GMT-02:00) Mid-Atlantic</MenuItem>
                                                <MenuItem value={"E. South America Standard Time"}>(GMT-03:00) Brasilia</MenuItem>
                                                <MenuItem value={"Argentina Standard Time"}>(GMT-03:00) Buenos Aires</MenuItem>
                                                <MenuItem value={"SA Eastern Standard Time"}>(GMT-03:00) Georgetown</MenuItem>
                                                <MenuItem value={"Greenland Standard Time"}>(GMT-03:00) Greenland</MenuItem>
                                                <MenuItem value={"Montevideo Standard Time"}>(GMT-03:00) Montevideo</MenuItem>
                                                <MenuItem value={"Newfoundland Standard Time"}>(GMT-03:30) Newfoundland</MenuItem>
                                                <MenuItem value={"Atlantic Standard Time"}>(GMT-04:00) Atlantic Time (Canada)</MenuItem>
                                                <MenuItem value={"SA Western Standard Time"}>(GMT-04:00) La Paz</MenuItem>
                                                <MenuItem value={"Central Brazilian Standard Time"}>(GMT-04:00) Manaus</MenuItem>
                                                <MenuItem value={"Pacific SA Standard Time"}>(GMT-04:00) Santiago</MenuItem>
                                                <MenuItem value={"Venezuela Standard Time"}>(GMT-04:30) Caracas</MenuItem>
                                                <MenuItem value={"SA Pacific Standard Time"}>(GMT-05:00) Bogota, Lima, Quito, Rio Branco</MenuItem>
                                                <MenuItem value={"Eastern Standard Time"}>(GMT-05:00) Eastern Time (US & Canada)</MenuItem>
                                                <MenuItem value={"US Eastern Standard Time"}>(GMT-05:00) Indiana (East)</MenuItem>
                                                <MenuItem value={"Central America Standard Time"}>(GMT-06:00) Central America</MenuItem>
                                                <MenuItem value={"Central Standard Time"}>(GMT-06:00) Central Time (US & Canada)</MenuItem>
                                                <MenuItem value={"Central Standard Time (Mexico)"}>(GMT-06:00) Guadalajara, Mexico City, Monterrey</MenuItem>
                                                <MenuItem value={"Canada Central Standard Time"}>(GMT-06:00) Saskatchewan</MenuItem>
                                                <MenuItem value={"US Mountain Standard Time"}>(GMT-07:00) Arizona</MenuItem>
                                                <MenuItem value={"Mountain Standard Time (Mexico)"}>(GMT-07:00) Chihuahua, La Paz, Mazatlan</MenuItem>
                                                <MenuItem value={"Mountain Standard Time"}>(GMT-07:00) Mountain Time (US & Canada)</MenuItem>
                                                <MenuItem value={"Pacific Standard Time"}>(GMT-08:00) Pacific Time (US & Canada)</MenuItem>
                                                <MenuItem value={"Pacific Standard Time (Mexico)"}>(GMT-08:00) Tijuana, Baja California</MenuItem>
                                                <MenuItem value={"Alaskan Standard Time"}>(GMT-09:00) Alaska</MenuItem>
                                                <MenuItem value={"Hawaiian Standard Time"}>(GMT-10:00) Hawaii</MenuItem>
                                                <MenuItem value={"Samoa Standard Time"}>(GMT-11:00) Midway Island, Samoa</MenuItem>
                                                <MenuItem value={"Dateline Standard Time"}>(GMT-12:00) International Date Line West</MenuItem>
                                                <MenuItem value={""}></MenuItem>
                                            </Select>
                                            {/*<FormHelperText>With label + helper text</FormHelperText>*/}
                                        </FormControl>
                                    </Grid>

                                    {/*<Grid item xs={12} lg={3}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="RegistrationDeadline-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="RegistrationDeadline-helper-label"*/}
                                {/*            required*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventRegistrationDeadline"*/}
                                {/*            label='Registration Deadline'*/}
                                {/*            type='datetime-local'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventRegistrationDeadline}*/}
                                {/*            onChange={async (e) => { await setEventRegistrationDeadline(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={12} lg={3}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="ByeRequestDeadline-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="ByeRequestDeadline-helper-label"*/}
                                {/*            required*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventByeRequestDeadline"*/}
                                {/*            label='Bye Request Deadline'*/}
                                {/*            type='datetime-local'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventByeRequestDeadline}*/}
                                {/*            onChange={async (e) => { await setEventByeRequestDeadline(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={12} lg={12}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <TextField*/}
                                {/*            required*/}
                                {/*            id="outlined-multiline-static"*/}
                                {/*            label="Event Description"*/}
                                {/*            multiline*/}
                                {/*            rows={8}*/}
                                {/*            value={eventDescription}*/}
                                {/*            defaultValue=""*/}
                                {/*            onChange={async (e) => { await setEventDescription(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={8} lg={4}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="eventFlyerUrl-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="eventFlyerUrl-helper-label"*/}
                                {/*            required*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventFlyerUrl"*/}
                                {/*            label='Link to Event Details or Flyer'*/}
                                {/*            type='url'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventFlyerUrl}*/}
                                {/*            onChange={async (e) => { await setEventFlyerUrl(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color='success'>Verify</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color="success">Copy</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={8} lg={4}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="eventRegistrationUrl-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="eventRegistrationUrl-helper-label"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventRegistrationUrl"*/}
                                {/*            label='Registration Link'*/}
                                {/*            type='url'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventRegistrationUrl}*/}
                                {/*            onChange={async (e) => { await setEventRegistrationUrl(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color='success'>Verify</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color="success">Copy</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={8} lg={4}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="eventPairingUrl-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="eventPairingUrl-helper-label"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventPairingUrl"*/}
                                {/*            label='Pairing and Result Link'*/}
                                {/*            type='url'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventPairingUrl}*/}
                                {/*            onChange={async (e) => { await setEventPairingUrl(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color='success'>Verify</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color="success">Copy</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={8} lg={4}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="eventLiveGameUrl-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="eventLiveGameUrl-helper-label"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventLiveGameUrleventLiveGameUrl"*/}
                                {/*            label='Live Game Link'*/}
                                {/*            type='url'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventLiveGameUrl}*/}
                                {/*            onChange={async (e) => { await setEventLiveGameUrl(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color='success'>Verify</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color="success">Copy</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={8} lg={4}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="eventHotelReservationLink-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="eventHotelReservationLink-helper-label"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventHotelReservationLink"*/}
                                {/*            label='Hotel Reservation Link'*/}
                                {/*            type='url'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventHotelReservationLink}*/}
                                {/*            onChange={async (e) => { await setEventHotelReservationLink(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color='success'>Verify</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color="success">Copy</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={8} lg={4}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 120 }}>*/}
                                {/*        <InputLabel fullWidth id="eventFideRegistrationLink-helper-label"></InputLabel>*/}
                                {/*        <TextField*/}
                                {/*            labelId="eventFideRegistrationLink-helper-label"*/}
                                {/*            size="small"*/}
                                {/*            fullWidth*/}
                                {/*            id="eventFideRegistrationLink"*/}
                                {/*            label='FIDE Event Link - Register 33 (norm event) or 6 days ahead'*/}
                                {/*            type='url'*/}
                                {/*            InputLabelProps={{ shrink: true, }}*/}
                                {/*            value={eventFideRegistrationLink}*/}
                                {/*            onChange={async (e) => { await setEventFideRegistrationLink(e.target.value) }}*/}
                                {/*        />*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color='success'>Verify</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                {/*<Grid item xs={2} lg={1}>*/}
                                {/*    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>*/}
                                {/*        <Button variant="outlined" color="success">Copy</Button>*/}
                                {/*    </FormControl>*/}
                                {/*</Grid>*/}
                                <Grid item xs={6} lg={4}>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                            <Button variant="contained" disabled={!eventName} onClick={onAddEventClicked}>Add Event</Button>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                    <Button variant="contained" color="error" onClick={onClearFormClicked}>Clear Form</Button>
                                </FormControl>
                                </Grid>
                                <Grid item xs={6} lg={2}>
                                    <FormControl fullWidth sx={{ m: 1, minWidth: 20 }}>
                                            <Button variant="contained" color="warning" onClick={onCancelClicked}>Cancel</Button>
                                    </FormControl>
                                </Grid>

                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Paper>
            </Box>
            <Dialog
                open={openEventFideRatedAlert}
                onClose={handleCloseFideEventAlert}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-eventDescription"
            >
                <DialogTitle id="alert-dialog-title">
                    {"FIDE Rated Event"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-eventDescription">
                        All FIDE events are required to be registered through USCF at least 33 days for norm events or at least 6 days for non-norm events before event starts. Make sure you have your event registered. If you have any questions please email fide@uschess.org. MetaDB Chess is not responsible for registering your FIDE rated event.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseFideEventAlert} autoFocus>
                        Got it!
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
        }
        {(!isOrganizer && !isAdmin) &&
                <Typography variant="h3">Only admin or organizer can add event</Typography>
        }
        </div>
    )
}
